import request from '@/utils/request'

// 获取品类
export function dictionaries(params){
    return request({
        url: "/api/Dictionaries/GetTypeList",
        method: 'get',
        params   
    })
}

// 获取名师列表
export function famousList(params){
    return request({
        url: "/api/Teacher/GetFamousList",
        method: 'get',
        params   
    })
}